import { initModfedDevtools } from './modfed-devtools';

function resolveStage(terraformConfig, remotesConfig) {
  if (terraformConfig?.stage) {
    return terraformConfig.stage;
  }
  if (remotesConfig.stage) {
    return remotesConfig.stage;
  }
  const stageMatch = /\b(nata|dev)\b/.exec(location.hostname);
  if (stageMatch) {
    return stageMatch[1];
  }
  return 'local';
}

Promise.all([
  fetch('/config.json')
    .then((r) => (r.ok ? r.json() : null))
    .catch(() => null),
  fetch('/remotes.json').then((r) => r.json())
])
  .then(([terraformConfig, remotesConfig]) => {
    const stage = resolveStage(terraformConfig, remotesConfig);
    const stageHost = (host) =>
      stage === 'prod'
        ? `https://${host}.simatic-ax.siemens.io`
        : `https://${host}.${stage}.simatic-ax.siemens.io`;

    const defaults = Object.fromEntries(
      remotesConfig.remotes.map(({ name, host, port, version }) => [
        name,
        stage === 'local'
          ? `http://localhost:${port}/remoteEntry.js`
          : `${stageHost(host)}/${version}/remoteEntry.js`
      ])
    );

    window.__REMOTES__ = { ...defaults };

    try {
      const overrides = JSON.parse(localStorage.getItem('modfed-overrides') || '{}');
      Object.keys(overrides).forEach((name) => {
        if (window.__REMOTES__[name] !== undefined) {
          window.__REMOTES__[name] = overrides[name];
        }
      });
    } catch (e) {
      console.warn('modfed-devtools: invalid overrides in localStorage', e);
    }

    initModfedDevtools(remotesConfig.remotes, defaults, stage);

    return import('./bootstrap.modfed');
  })
  .catch((err) => {
    console.error('Failed to initialize remotes:', err);
  });
